module.exports = __webpack_public_path__ + "static/img/team-img-bg.ee820cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/team-img-bg.png
// module id = SJqP
// module chunks = 0